import { FaRegCopyright } from "react-icons/fa";
export const Footer = () => {
    return (
        <footer className="flex items-center justify-center h-6 p-5 gap-1 dark:text-white bg-white dark:bg-slate-950"> <FaRegCopyright/>2024 por Ingrid</footer>
    )
}